<div class="events-add-placeholder mt-2 mb-2" (click)="onAdd()">
  <i class="material-symbols-outlined">add_circle</i>
  <span class="events-add-placeholder-no-type">{{ T.common.no_item_to_display | translate: { item: plural } }}</span>
  <span class="events-add-placeholder-add-type">{{ T.common.add_item | translate: { item: singular } }}</span>
</div>
